import React, {useState} from "react";
import {useNavigationParse} from "@mindarc/arctheme-components/frontend/src/hooks/useNavigationParse";
import Alpine from "alpinejs";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import {Accordion} from "./Layouts/Accordion";
import {Drilldown} from "./Layouts/Drilldown";

const Layouts = {
    "accordion": Accordion,
    "drilldown": Drilldown,
};

export function HeaderMobileMenuLinks({ settings, link_list, updateMenuState })
{
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

    const menuLinks = link_list[0]?.links;
    const megamenuBlocks = settings.blocks.filter(block => block.type === 'mobile_megamenu');
    const [expandedSections, setExpandedSections] = useState({});
    const linksStyle = 'h4';
    const useAccordions = true;

    const layout = isMobile ? 'accordion' : 'drilldown';
    const LayoutComponent = Layouts[layout];

    const toggleSection = (index) => {
        setExpandedSections((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const menuItemClicked = (dataId) => {
        if (!useAccordions) {
            updateMenuState({
                menuAnimClass: "slide-out-left",
            });

            Alpine.store("navigation").setMenuId(`header-${dataId}`);
        }
    };
    return (
        <>
            {menuLinks.map((link, index) => {
                const text = useNavigationParse(link.title);
                const isOpen = expandedSections[index];

                const megamenuBlock = megamenuBlocks.find(block => block.settings.attach_to === link.title);

                return (
                    <li
                        key={index}
                        className="mobile-menu-item menu-item flex flex-col"
                    >
                        <div
                            className="flex w-full justify-between items-center cursor-pointer"
                            onClick={() => {
                                if (useAccordions) {
                                    toggleSection(index);
                                } else {
                                    menuItemClicked(link.title.toLowerCase().replace(" ", "-"));
                                }
                            }}
                        >
                            {megamenuBlock?.links?.length > 0 ? (
                                <span className={`inline-flex justify-center gap-[8px] ${linksStyle}`}>
                                    {text.text.toUpperCase()}
                                </span>
                            ) : (
                                <a href={link.url} className={`${linksStyle}`}>
                                    <span className={`inline-flex justify-center gap-[8px]`}>
                                        {text.text.toUpperCase()}
                                    </span>
                                </a>
                            )}
                            {megamenuBlock?.links?.length > 0 && (
                                <i
                                className={`icon-arrow-right mobile-menu__icon transition-transform duration-200 origin-center ${
                                  isOpen ? "rotate-90" : "rotate-0"
                                }`}
                              ></i>
                          
                            )}
                        </div>

                        <LayoutComponent
                            isOpen={isOpen}
                            settings={settings}
                            megamenuBlock={megamenuBlock}
                        />
                    </li>
                );
            })}
        </>
    );
}
